export default function About() {
  return (
    <main data-testid="about-page" className="px-6 md:px-12 lg:px-16 pt-16 pb-24">
      <div className="label-eyebrow mb-6">About / Why The Extension Works</div>
      <h1 className="font-black tracking-tighter leading-[0.95] text-5xl md:text-7xl max-w-4xl">A ground-up contractor. Not a marketplace.</h1>
      <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 space-y-6 text-[#6B7280] leading-relaxed text-lg">
          <p>The Extension Works is the homeowner-facing arm of Esskay Homes Limited — a Berkshire-based building company that has spent the past decade refining a single, narrow product: the single-storey rear extension done properly.</p>
          <p>We hold the architectural design, the structural calculations and the on-site team in-house. Building Control is booked under our name. There is one phone number, one project lead, one warranty, and one fixed price written down before a spade goes in the ground.</p>
          <p>The website you are using exists because that whole proposition can — and should — be self-served. You shouldn't have to wait three weeks for a quote to find out an extension is going to cost more than your kitchen budget. So we built a configurator that gives you the honest number in minutes.</p>
        </div>
        <div className="de-card p-8">
          <div className="label-eyebrow mb-4">Company</div>
          <div className="text-sm leading-relaxed">
            Company No. 11076237<br/>VAT No. 295080977<br/>Main line: 0203 488 1081
          </div>
          <div className="de-hr my-8" />
          <div className="label-eyebrow mb-4">Standards</div>
          <ul className="text-sm space-y-2">
            <li>12-month workmanship warranty</li>
            <li>VAT registered — prices include VAT</li>
            <li>Building Control booked on every job</li>
            <li>Public liability insured</li>
          </ul>
        </div>
      </div>
      <p className="text-xs text-[#6B7280] mt-16" data-testid="about-registered-office">
        Registered office: Esskay Homes Limited, 30A York Road, Aldershot, GU11 3JP
      </p>
    </main>
  );
}
